export default __webpack_public_path__ + "static/funnel-steps-light-mode-397adf447ce3852b1c2cbd6d7cc3e960.png";